import { Observable } from "rxjs/Observable";
import * as actions from "./access-group.actions";
import { AccessGroup } from "./access-group.model";
import { AccessGroupFilters } from "./access-group.reducer";
import { CategoryStoreFacade } from "../category/category.store-facade";
import { ActionOptionsArgs } from "../../../core/store/actions/base-actions";
import { Qry } from "../query-facade";

export class AccessGroupStoreFacade extends CategoryStoreFacade<AccessGroup> {

    getAll(): Observable<Array<AccessGroup>> {
        return this.select(Qry.getInstance().accessGroup.byActiveAccount);
    }

    getAllByAccount(accountId: string): Observable<Array<AccessGroup>> {
        return this.select(Qry.getInstance().accessGroup.byAccount(accountId));
    }

    getForAllAccounts(): Observable<Array<AccessGroup>> {
        return this._getForAllAccounts("accessGroup", "accessGroups");
    }

    create(accessGroup: AccessGroup): void {
        this.dispatch(new actions.SubmitAction(accessGroup));

        this.appFacade.objects.membership.store.getActive().take(1).subscribe(membership => {
            this.appFacade.objects.membership.store.attachAccessGroup(membership, accessGroup, {
                restful: false,
                persistable: true
            });
        });

        this.appFacade.objects.membership.store.enqueueRefresh();
    }

    insert(accessGroup: AccessGroup): void {
        this.dispatch(new actions.SubmitAction(accessGroup, {persistable: true, restful: false}));
    }

    update(accessGroup: AccessGroup): void {
        this.dispatch(new actions.SubmitAction(accessGroup));
    }

    remove(accessGroup: AccessGroup, options?: ActionOptionsArgs): void {

        this.checkCanDelete(accessGroup);

        // remove all RestrictedAccountObjects referenced by the access group
        this.appFacade.objects.contact.store.removeByAccessGroup(accessGroup);
        this.appFacade.objects.control.store.removeByAccessGroup(accessGroup);
        this.appFacade.objects.form.store.removeByAccessGroup(accessGroup);
        this.appFacade.objects.group.store.removeByAccessGroup(accessGroup);
        this.appFacade.objects.job.store.removeByAccessGroup(accessGroup);
        this.appFacade.objects.lookup.store.removeByAccessGroup(accessGroup);
        this.appFacade.objects.reportLayout.store.removeByAccessGroup(accessGroup);

        // detach the access group from any memberships that reference it
        this.appFacade.objects.membership.store.getActive().take(1).subscribe(membership => {
            this.appFacade.objects.membership.store.detachAccessGroup(membership, accessGroup, {
                restful: false,
                persistable: true
            });
        });

        // remove the access group
        this.dispatch(new actions.RemoveAction(accessGroup, options));

        this.appFacade.objects.membership.store.enqueueRefresh();
    }

    setFilters(filters: AccessGroupFilters): void {
        this.dispatch(new actions.SetFilterAction(filters));
    }

    canDelete(accessGroup: AccessGroup): Observable<boolean> {
        return Observable.zip(
            this.checkHasDependency(this.appFacade.objects.contact.store, accessGroup, "Contacts"),
            this.checkHasDependency(this.appFacade.objects.control.store, accessGroup, "Controls"),
            this.checkHasDependency(this.appFacade.objects.form.store, accessGroup, "Forms"),
            this.checkHasDependency(this.appFacade.objects.group.store, accessGroup, "Groups"),
            this.checkHasDependency(this.appFacade.objects.job.store, accessGroup, "Jobs"),
            this.checkHasDependency(this.appFacade.objects.lookup.store, accessGroup, "Lookups"),
            this.checkHasDependency(this.appFacade.objects.reportLayout.store, accessGroup, "Report Layouts")
        )
            .switchMap(() => super.canDelete(accessGroup));
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/access-group/access-group.store-facade.ts